import { createTheme, Theme } from "@material-ui/core/styles";
import { lighten, darken } from "@material-ui/core/styles/colorManipulator";

const baseFontSize = 14; // .875rem

export const theme: Theme = createTheme({
  spacing: 16, // 1rem
  palette: {
    common: {
      black: "#000",
      white: "#fff",
    },
    type: "light",
    primary: {
      light: lighten("#11a5c5", 0.1),
      main: "#11a5c5",
      dark: darken("#11a5c5", 0.4),
      contrastText: "#fff",
    },
    secondary: {
      light: lighten("#F26839", 0.1),
      main: "#F26839",
      dark: darken("#F26839", 0.4),
      contrastText: "#fff",
    },
    error: {
      main: "#A94442",
    },
    warning: {
      main: "#8A6D3B",
    },
    info: {
      main: "#31708F",
    },
    success: {
      main: "#3C763D",
    },
    background: {
      default: "#fff",
    },
  },
  typography: {
    fontSize: baseFontSize,
    fontFamily: `"Spartan", Sans-serif`,
    h1: {
      fontSize: baseFontSize * 2.25,
    },
    h2: {
      fontSize: baseFontSize * 2,
    },
    h3: {
      fontSize: baseFontSize * 1.75,
    },
    h4: {
      fontSize: baseFontSize * 1.5,
    },
    h5: {
      fontSize: baseFontSize * 1.25,
    },
  },
});

theme.overrides = {
  MuiButton: {
    root: {
      textTransform: "none",
    },
  },
};
